import React from 'react'
import PropTypes from 'prop-types'
import Breadcrumb from 'components/Breadcrumb'
import Loading from 'components/Loading'
import { Link } from 'react-router'
import Moment from 'moment'

import PageTitle from './PageTitle'
import ChatWork from './ChatWork'
import Item from './Item'

import Styles from './index.scss'

const Detail = props => (
  <div className="page-content">
    {props.isLoading && (<Loading />)}
    <Breadcrumb data={props} />
    <div className="row">
      <PageTitle />
    </div>
    <div className="col-xs-7">
      {
        Object.keys(props.taskDetailData).length !== 0 && (
          <div className={Styles.Title}>
            <h2>{props.taskDetailData.task.profile.name}</h2>
            <div style={{ marginBottom: '30px', marginTop: '30px' }}>
              <ul style={{ paddingLeft: '0px', listStyleType: 'none' }}>
                <li><span>{`Workspace Name: ${props.taskDetailData.task.profile.name}`}</span></li>
                <li><span>{`Service Name  : ${props.taskDetailData.task.order.service.name}`}</span></li>
              </ul>
            </div>
          </div>
        )
      }
      <h4>Chat Work</h4>
      <div className={`${Styles.main}`}>
        {
          Object.keys(props.taskDetailData).length !== 0 &&
          (props.taskDetailData.chats.map((row, key) => (
            <ChatWork
              indexKey={key}
              key={row.id}
              row={row}
            />
          )))
        }
      </div>
    </div>
    {
      Object.keys(props.taskDetailData).length !== 0 && (
        <div style={{ float: 'right' }} className="col-xs-2">
          <Link to={`/projects/${props.taskDetailData.task.order.id}`}>
            <button
              type="button"
              className="btn green"
            >
              To Project Detail
            </button>
          </Link>
        </div>
      )
    }
    {
      Object.keys(props.taskDetailData).length !== 0 && (
        <div style={{ float: 'right' }} className="col-xs-3">
          <Link to="/tasklist">
            <button
              type="button"
              className="btn green"
            >
              Back To Task List
            </button>
          </Link>
        </div>
      )
    }
    <div className="portlet-body">
      {
          Object.keys(props.taskDetailData).length !== 0 && (
            <div className="table-scrollable table-scrollable-borderless" style={{ paddingTop: '100px', paddingLeft: '9px' }}>
              <span><strong>Task Log</strong></span>
              <div style={{ marginBottom: '30px', marginTop: '30px' }}>
                <ul style={{ paddingLeft: '0px', listStyleType: 'none' }}>
                  <li><span>{`Task Started  : ${Moment(`${props.taskDetailData.task.createdAt}`).format('DD MMMM YYYY - h:mm')}`}</span></li>
                  <li>
                    {
                      props.taskDetailData.task.status === 2
                      ? <span>{`Task Completed  : ${Moment(`${props.taskDetailData.task.updatedAt}`).format('DD MMMM YYYY - h:mm')}`}</span>
                      : 'Task Completed  : -'
                    }
                  </li>
                </ul>
              </div>
            </div>
          )
        }
      <table className="table table-hover table-light">
        <thead>
          <tr className="uppercase">
            <th> No </th>
            <th> File Name </th>
            <th> Date Uploaded </th>
            <th> Caption </th>
          </tr>
        </thead>
        <tbody>
          { Object.keys(props.taskDetailData).length !== 0 &&
            (props.taskDetailData.works.map((row, key) => (
              <Item
                indexKey={key}
                key={row.id}
                row={row}
              />
            )))
          }
        </tbody>
      </table>
    </div>
  </div>
)

Detail.propTypes = {
  taskDetailData: PropTypes.shape({
    chats: PropTypes.array,
    works: PropTypes.array,
    task: PropTypes.shape({
      order: PropTypes.shape({
        id: PropTypes.string.isRequired,
        service: PropTypes.shape({
          name: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
      status: PropTypes.number.isRequired,
      createdAt: PropTypes.string.isRequired,
      updatedAt: PropTypes.string.isRequired,
      profile: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
}

export default Detail
